import { useState, useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import classes from './InputWithButton.module.scss'
import { useMediaQuery, useTranslate } from "@educaplay/core/hooks";
import { Button, COLORS, NAME_SOUND_ACTIVE, NAME_SOUND_HOVER, useGameSounds } from '@educaplay/core';

import { motion, useAnimate } from "framer-motion"
import clsx from 'clsx';
import InputTop from '../InputTop';
import { useSelector } from 'react-redux';
import { NextSubmitButton } from "@educaplay/core/components";
import { NextIcon, SubmitIcon } from '@educaplay/core/components/NextSubmitButton/Icons';


export const InputWithButton = forwardRef(function InputWithButton(props, ref) {

    const { onSubmit, heightBall, onFocus, onBlur, setInputEmpty, composeRef, mobileView } = props;
    const isAnimating = useSelector(state => state.game.isAnimating);
    const isCompleteEntryAnimation = useSelector(state => state.game.isCompleteEntryAnimation);
    const [isInputEmpty, setIsInputEmpty] = useState(true);
    const isTouchDevice = (useMediaQuery("(hover:none)") || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0));
    const inputComposeRef = useRef(null);
    const inputRef = useRef(null);
    const t = useTranslate();
    const gameSound = useGameSounds();
    const [inputWrapperRef, animateInput] = useAnimate();
    const [buttonRef, animateButton] = useAnimate();
    const iOS = /iPad|iPhone|iPod/.test(navigator.platform);
    const question = useSelector(state => state.game.questions[state.game.currentIndex])
    const currentChar = useSelector(state => state.game.questions[state.game.currentIndex].text)
    const isFirstTime = useRef(true);

    const inputHandler = (event) => {
        setIsInputEmpty(event.target.value.trim() === '');
    }

    const soundInputHandler = (event) => {
        if (event.key === 'Backspace' && !isTouchDevice && !isInputEmpty) {
            gameSound.play('wheel-delete');
        }

        if (event.key !== 'Backspace' && event.key !== 'Shift' && event.key !== "ArrowLeft" && event.key !== 'ArrowRight' && event.key!== 'Enter' && !isTouchDevice) {
            gameSound.play('wheel-write');
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if(isAnimating || !isCompleteEntryAnimation) return;

        if(isInputEmpty){
            inputRef.current?.focus();
        } 
        else{
            gameSound.play('wheel-submit');
        } 
        onSubmit(e.target[0].value.trim());
        
        inputRef.current.value = "";
        if (isTouchDevice) inputComposeRef.current.value = "";

        setIsInputEmpty(true);
    }

    const handleFocus = () => {
        if (!isTouchDevice) return;
        inputComposeRef.current?.focus();
    }

    const ChangeInputMobile = (word) => {
        inputRef.current.value = word;
        setIsInputEmpty(!word);
    }

    const MouseEnterHandler = () => {
        gameSound.play(NAME_SOUND_HOVER);
    }


    useEffect(() => {
        setInputEmpty(isInputEmpty);
        if(isFirstTime.current) {
            isFirstTime.current = false;
            return;
        }
        gameSound.play(NAME_SOUND_ACTIVE);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInputEmpty])

    useImperativeHandle(ref, () => ({
        animateEntry: async () => {
            await animateInput(inputWrapperRef.current, { opacity: 1 });
            await animateButton(buttonRef.current, { opacity: 1 });
            if (!iOS) inputRef.current.focus();
        }
    }));

    return (
        <>
            <form className={classes.form} onSubmit={handleSubmit}>
                <motion.div className={classes.inputWrapper} style={{ width: 2 * (heightBall - 20) }} initial={{ opacity: 0 }} ref={inputWrapperRef} >
                            <div className={classes.inputTitle} style={{opacity: (mobileView ? 0 : 1) ,fontSize: 'min( 22px , ' + ((heightBall / 5) * 66.6) / 100 + 'px )' }}>{question.isStartLetter ? t('specific.beginsWith') : t('specific.contains')} <span className={classes['inputTitle__character']}>{currentChar}</span></div>
                            <input ref={inputRef} className={classes.input} onChange={inputHandler} onKeyDown={soundInputHandler} type="text" onFocus={handleFocus} style={{opacity: (mobileView ? 0 : 1) ,fontSize: 'min( 28px , ' + ((heightBall / 5) * 66.6) / 100 + 'px )' }} />
                </motion.div>
                <motion.div initial={{ opacity: 0 }} ref={buttonRef} >
                    {isTouchDevice ?
                        !mobileView && (<NextSubmitButton showSubmit={!isInputEmpty} className={classes.button} />)
                        :
                        <div className={classes.buttonWrapper} style={{ width: heightBall * 1.8 - (isTouchDevice ? 36 : 64), fontSize: 'min( 20px , ' + ((heightBall / 5) * 66.6) / 100 + 'px ) ' }}>
                            <Button type={'submit'} icon={!isInputEmpty ? <SubmitIcon color={COLORS.contrastBlackOrigin} /> : <NextIcon color={COLORS.primary} />} className={clsx({
                                [classes.textButton]: true,
                                [classes['textButton--submit']]: !isInputEmpty,
                                [classes['textButton--next']]: isInputEmpty
                            })
                            }
                                onMouseEnter={MouseEnterHandler}
                            >
                                {!isInputEmpty ? t('specific.submit') : t('specific.next')}
                            </Button>
                        </div>
                    }
                </motion.div>
            </form>

            {isTouchDevice && <InputTop
                mobileView={mobileView}
                ref={inputComposeRef}
                composeRef={composeRef}
                handleSubmit={handleSubmit}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={ChangeInputMobile}
                isInputEmpty={isInputEmpty}
                isStartLetter={question.isStartLetter}
                currentChar={currentChar}
                heightBall={heightBall}
            />}

        </>
    )
})